import React, { useEffect, useState } from 'react';
import style from './MissionsMain.scss';
import { usePortletTranslations } from '../../../../system/Portlet/hooks';
import { MissionsRewardInfoBlock } from '../MissionsRewardInfoBlock';
import { MissionsCardDetailsInfo } from '../MissionsCardDetailsInfo';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

export const MissionsMain = (props) => {

    const { showBoostPrizes, leaderboardEndTime } = props;
    const cancelledOrRegistrationClosed = props.status === 'CANCELLED_BY_ADMIN' ||
        (props.status !== 'COMPLETED' || props.status !== 'PENDING_REVIEW') &&
        props.registrationStatus === 'FINISHED' && !props.joined;

    const calculateStatus = (boostValue) => {
        if ((boostValue.status === 'COMPLETED' || boostValue.status === 'DISABLED') &&
            boostValue.boostCountLimit > boostValue.boostCountLimitUsed ||
            boostValue.boostCountLimit === boostValue.boostCountLimitUsed) {
            boostValue['order'] = 10;
        } else {
            boostValue['order'] = 1;
        }
    };
    const t = usePortletTranslations();

    const boostArray = {};
    const [realBoostArray, setRealBoostArray] = useState([]);
    const [missionsCountState, setMissionsCountState] = useState(0);
    const [completedMissionsCountState, setCompletedMissionsCountState] = useState(0);

    const calculateCardsNumber = () => {
        let missionsCount = 0;
        for (const prop in props) {
            if (prop.startsWith('boost_')) {
                const arr = prop.split('_');
                if (arr.length === 3 && (arr[2] === 'name' || arr[2] === 'description' || arr[2] === 'url' || arr[2] === 'image')) {
                    const key = arr[1];
                    const value = `${arr[2]}Mission`;
                    let missionInfo;
                    if (boostArray[key]) {
                        missionInfo = boostArray[key];
                        missionInfo[value] = props[prop];
                        missionInfo.id = key;
                    } else {
                        missionInfo = {};
                        missionInfo[value] = props[prop];
                        missionInfo.id = key;
                        missionsCount++;
                    }
                    boostArray[key] = missionInfo;
                }
            }
        }
        return missionsCount;
    };

    const calculateCompletedMissionsCount = () => {
        let completedMissionsCount = 0;
        for (const key in boostArray) {
            for (let i = 0; i < props.originalLeaderboardRules.length; i++) {
                if (props.originalLeaderboardRules[i].boostCountLimit && key === `${props.originalLeaderboardRules[i]['ruleCode']}`) {
                    boostArray[key] = { ...boostArray[key], ...props.originalLeaderboardRules[i] };
                    if (boostArray[key].boostCountLimit === boostArray[key].boostCountLimitUsed) {
                        completedMissionsCount++;
                    }
                    calculateStatus(boostArray[key]);
                }
            }
        }
        return completedMissionsCount;
    };

    const calculateBoostRules = () => {
        for (const key in boostArray) {
            const boostArrayItem = boostArray[key];
            for (let i = 0; i < props.boostBasedPrizes.length; i++) {
                const ruleCodesArray = props.boostBasedPrizes[i]['ruleCodes'];
                for (let j = 0; j < ruleCodesArray.length; j++) {
                    if (ruleCodesArray[j] === boostArrayItem['ruleCode']) {
                        boostArray[key] = { ...boostArray[key], ...props.boostBasedPrizes[i] };
                        break;
                    }
                }
            }
        }
    };

    const calculateCardRule = () => {
        for (const boost in boostArray) {
            Object.assign(boostArray[boost], { rule: props.originalLeaderboardRules.find((rule) => rule
                    && boostArray[boost] && rule.ruleCode === boostArray[boost].ruleCode) });
        }
    };

    const convertObjectToArray = () => {
        return Object.keys(boostArray).map((key) => boostArray[key]);
    };

    const sort = (el1, el2) => {
        const orderDiff = el1.order - el2.order;
        if (orderDiff === 0) {
            return el1.ruleCode - el2.ruleCode;
        }
        return el1.order - el2.order;
    };

    useEffect(() => {
        if (!cancelledOrRegistrationClosed) {
            setMissionsCountState(calculateCardsNumber());
            setCompletedMissionsCountState(calculateCompletedMissionsCount());
            calculateBoostRules();
            // Add rule info to data object.
            calculateCardRule();
            const array = convertObjectToArray().sort(sort);
            setRealBoostArray(array);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.leaderboardRules]);

    return (
        <div className={style.wrapper}>
            <div className={style.headerTitleWrapper}>
                <div className={style.headerTitle}>{t('missions')}</div>
            </div>
            <div className={style.descriptionWrapper}>
                {!cancelledOrRegistrationClosed && props.eventCount === props.eventCountLimit &&
                <div className={style.congratsBlock}>
                    <span className={style.congrats}>{`${t('allMissionsCompletedInfoCongrats')} `}</span>
                    <span>{t('allMissionsCompletedInfoCongratsDeatils')
                        .replace('{0}', `${missionsCountState}`)
                        .replace('{1}', `${props.name}`)}
                    </span>
                </div>}
                {cancelledOrRegistrationClosed || props.eventCount !== props.eventCountLimit && <div>{props.description}</div>}
            </div>
            {!cancelledOrRegistrationClosed && <div className={style.rewardWrapper}>
                {props.showEventPrizes &&
                <MissionsRewardInfoBlock mainText="allMissionsCompletedReward"
                                         prizeDescriptionText={props.eventBasedPrizes[0].description}
                                         isNotInCard={true} />}
                <div>
                    <span className={style.missionsComplete}>{t('missionsComplete')}</span>
                    <span className={style.circle}>{completedMissionsCountState}</span>
                    <span className={style.missionsComplete}>{`${t('of')} ${missionsCountState}`}</span>
                </div>
            </div>}
            {!cancelledOrRegistrationClosed && <div className={style.missionsCardBlock}>
                <TransitionGroup className={style.missionsList} unmountOnExit={true}>
                {realBoostArray.map((boost, index) =>
                    <CSSTransition key={boost.ruleCode} timeout={500} classNames={{
                        enter: style.missionEnter,
                        enterActive: style.missionEnterActive,
                        enterDone: 'my-done-enter',
                        exit: style.missionExit,
                        exitActive: style.missionExitActive,
                        exitDone: 'my-done-exit'
                    }}>
                        <MissionsCardDetailsInfo key={boost.ruleCode}
                                                 leaderboardEndTime={leaderboardEndTime}
                                                 showBoostPrizes={showBoostPrizes}
                                                 data={boost}
                                                 isLast={realBoostArray.length - 1 === index}/>
                    </CSSTransition>)}
                </TransitionGroup>
            </div>}
        </div>
    );
};

